<script setup lang="ts">
import GeneralLayout from '@/layout/GeneralLayout.vue';
import sadFace from '@/assets/icons/face-sad-cry-regular.svg';
import { useRoute } from 'vue-router';

const route = useRoute();
const correlationId = route?.query?.correlationId as string;
const currentTime = new Date().toUTCString();
</script>

<template>
  <GeneralLayout>
    <div class="my-12 flex flex-col px-4" data-test="screen-timeout">
      <img :src="sadFace" class="mb-3 size-16" />
      <h1 class="mb-4 text-3xl">Oops! Your session timed out</h1>
      <p class="text-light-secondary dark:text-dark-secondary mb-8">
        It looks like your session took too long and timed out. Try again to pick up where you left
        off.
      </p>
      <p v-if="correlationId" class="text-light-secondary dark:text-dark-secondary mb-8">
        If the problem keeps happening, contact support and reference {{ correlationId }}
        {{ currentTime }}.
      </p>
    </div>
  </GeneralLayout>
</template>

<style scoped></style>
